/* Shared production flow (r2 2026-09-08): native customer form; no email in storage or analytics.
   r2: launcher always visible (label switches to クーポン適用済み), thanks = 買い物を続ける (close + restore scroll),
   no "確認しています" flash, per-unit discount, one-purchase lock (ec-coupon-used-<brand>, set by pixel or cart-token heuristic). */
(function () {
  'use strict';
  function init() {
    const config = document.querySelector('#ec-coupon-config');
    if (!config || window.EC_COUPON_UI) return;
    const brand = config.dataset.brand, preview = config.dataset.preview === 'true';
    const api = brand === 'kokochi' ? window.KD_COUPON : window.WD_COUPON;
    if (!api) return;
    const modal = document.querySelector('.sign-up-popup-modal.qp-modal');
    const overlay = document.querySelector('.sign-up-popup-overlay');
    const launcher = document.querySelector('[data-coupon-launcher]');
    const steps = Object.fromEntries([...modal.querySelectorAll('[data-step]')].map(x => [x.dataset.step,x]));
    const form = modal.querySelector('.newsletter-form'), tags = form.querySelector('[data-qp-tags]');
    const storageKey = `ec-coupon-flow-v1-${brand}-${preview ? 'preview' : 'live'}`;
    const pendingKey = storageKey + '-pending';
    const usedKey = `ec-coupon-used-${brand}`, cartKey = `ec-coupon-cart-${brand}`;
    const eligibleKey = brand === 'kokochi' ? 'kokochi-newsletter-offer-v2' : 'wandry-newsletter-offer-v1';
    const root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    let state = {}, pendingSignup = null;
    try { state = JSON.parse(localStorage.getItem(storageKey) || '{}') || {}; } catch (_) {}
    try { pendingSignup = JSON.parse(sessionStorage.getItem(pendingKey) || 'null'); } catch (_) {}
    const params = new URLSearchParams(location.search);
    const stage = preview ? params.get('coupon_stage') : null;
    const replay = preview && params.get('coupon_replay') === '1';
    // Preview reset affects presentation only. It never grants discount eligibility.
    if (replay) state = {};
    let opened = false, timer, raf, transition, restore = null, origin = null, blockers = [];
    let activeStep = null, submitBusy = false, verifying = false;
    const reduced = matchMedia('(prefers-reduced-motion: reduce)').matches;
    const save = () => { try { localStorage.setItem(storageKey, JSON.stringify(state)); } catch (_) {} };
    const measure = name => { if (!preview) { try { window.EC_MEASURE?.event(name); } catch (_) {} } };
    const amountValue = Number(config.dataset.amount), amount = amountValue.toLocaleString('ja-JP');
    const small = launcher.querySelector('small'), strong = launcher.querySelector('strong');
    if (small && !small.dataset.label) small.dataset.label = small.textContent;

    function isUsed() { try { return !!localStorage.getItem(usedKey); } catch (_) { return false; } }
    function markUsed(reason) {
      try { localStorage.setItem(usedKey, JSON.stringify({at:Date.now(),reason})); localStorage.removeItem(eligibleKey); localStorage.removeItem(cartKey); } catch (_) {}
      if (api.forget) api.forget();
      state.seen = true; save();
      if (opened) close();
      launcher.hidden = true;
      measure('coupon_used');
    }
    // Fallback purchase detection: the cart token recorded when the discount was applied has been replaced by an empty new cart.
    async function detectPurchase() {
      let rec = null; try { rec = JSON.parse(localStorage.getItem(cartKey) || 'null'); } catch (_) {}
      if (!rec || !rec.token) return false;
      if (Date.now() - (Number(rec.at) || 0) > 14 * 864e5) { try { localStorage.removeItem(cartKey); } catch (_) {} return false; }
      try {
        const cart = await (await fetch(root + 'cart.js', {cache:'no-store'})).json();
        const now = String(cart.token || '').split('?')[0], was = String(rec.token).split('?')[0];
        if (now && now !== was && cart.item_count === 0) { markUsed('cart-replaced'); return true; }
      } catch (_) {}
      return false;
    }
    // 購入完了後、カートに自社コードが残っていれば外す（他のコードには触らない）
    async function stripOwnCode() {
      const code = String(config.dataset.code || '').toUpperCase(); if (!code) return;
      try {
        const cart = await (await fetch(root + 'cart.js', {cache:'no-store'})).json();
        const codes = (cart.discount_codes || []).map(d => String(d.code));
        if (!codes.some(c => c.toUpperCase() === code)) return;
        await fetch(root + 'cart/update.js', {method:'POST', headers:{'Content-Type':'application/json'}, body: JSON.stringify({discount: codes.filter(c => c.toUpperCase() !== code).join(',')})});
      } catch (_) {}
    }
    function syncLauncher() {
      if (isUsed()) { launcher.hidden = true; return; }
      const eligible = !!api.isEligible();
      const verified = !!api.isApplied();
      launcher.classList.toggle('is-applied', verified);
      if (small) small.textContent = eligible ? amount + '円OFF' : small.dataset.label;
      if (strong) strong.textContent = eligible ? (verified ? 'クーポン適用済み' : '登録済み') : amount + '円OFF';
      launcher.setAttribute('aria-label', eligible ? (verified ? 'クーポン適用済み。内容を見る' : '登録済み。内容を見る') : amount + '円OFFの特別クーポンを開く');
      if (!opened) launcher.hidden = false;
    }
    function cancel() { clearTimeout(timer); clearTimeout(transition); cancelAnimationFrame(raf); transition = null; }
    function setStep(name) {
      clearTimeout(transition); transition = null;
      activeStep = name;
      Object.entries(steps).forEach(([k,el]) => { el.hidden = k !== name; el.classList.toggle('is-active',k === name); el.classList.remove('is-leaving'); });
      modal.classList.remove('count-running');
      const heading = steps[name].querySelector('h2');
      if (heading) modal.setAttribute('aria-labelledby', heading.id);
    }
    function focusStep() {
      const el = steps[activeStep].querySelector('input:not([type=hidden]),button:not(:disabled)') || modal.querySelector('.qp-close');
      el?.focus({preventScroll:true});
    }
    function count() {
      const el = modal.querySelector('#visitor-count'), target = Number(el.dataset.target);
      const start = performance.now();
      function end() { modal.classList.remove('count-running'); transition = setTimeout(() => { steps.intro.classList.add('is-leaving'); transition = setTimeout(() => { setStep('offer'); focusStep(); }, reduced ? 0 : 280); }, reduced ? 1100 : 700); }
      if (reduced) { el.textContent = target.toLocaleString('ja-JP'); end(); return; }
      modal.classList.add('count-running');
      function tick(now) {
        const p = Math.min(Math.max((now-start)/1700,0),1); // rAFの時刻がstartより前だと負の数が1フレーム出るため下限0
        el.textContent = Math.round(target*(1-Math.pow(1-p,3))).toLocaleString('ja-JP');
        if (p < 1) raf = requestAnimationFrame(tick); else end();
      }
      raf = requestAnimationFrame(tick);
    }
    function lock() {
      // Lock siblings along the ancestor chain, leaving the Shopify popup interactive.
      let child = modal;
      while (child.parentElement && child !== document.body) {
        [...child.parentElement.children].forEach(el => {
          if (el !== child && el instanceof HTMLElement && !['SCRIPT','STYLE','LINK'].includes(el.tagName)) {
            blockers.push([el,el.inert]); el.inert = true;
          }
        });
        child = child.parentElement;
      }
      document.documentElement.style.overflow = 'hidden'; document.body.style.overflow = 'hidden';
    }
    function showApplied() {
      const title = steps.thanks.querySelector('h2'), status = steps.thanks.querySelector('[data-coupon-status]');
      function updateStatus() {
        const verified = !!api.isApplied();
        title.innerHTML = verified ? amount + '円OFF<br>適用しました。' : '登録が完了しました。';
        status.textContent = verified ? 'コード入力は不要です。' : '割引の適用条件と金額は購入手続きでご確認ください。';
        syncLauncher();
      }
      updateStatus();
      if (verifying) return; verifying = true;
      Promise.resolve().then(() => api.apply()).then(cart => {
        updateStatus();
        if (api.isApplied()) measure('coupon_applied');
        if (cart && brand === 'kokochi' && window.KD_CART_SYNC) return KD_CART_SYNC.refresh(cart).catch(() => {});
      }).catch(() => {
        updateStatus();
        status.textContent = '割引を確認できませんでした。カートでもう一度お試しください。'; measure('coupon_failed');
      }).finally(() => { verifying = false; });
    }

    function open(force) {
      cancel();
      if (isUsed()) return;
      if (!opened) {
        origin = document.activeElement;
        restore = {x:window.scrollX,y:window.scrollY,html:document.documentElement.style.overflow,body:document.body.style.overflow};
        if (pendingSignup && Number.isFinite(pendingSignup.y)) restore.y = pendingSignup.y;
        lock();
      }
      opened = true; modal.inert = false;
      let next = force || (api.isEligible() ? 'thanks' : state.answer ? 'email' : state.seen ? 'offer' : 'intro');
      if (!steps[next] || (next === 'thanks' && !api.isEligible())) next = 'intro';
      state.seen = true; save();
      setStep(next); modal.classList.add('popup-modal--active'); overlay?.classList.add('popup-overlay--active');
      launcher.hidden = true; launcher.setAttribute('aria-expanded','true');
      measure('popup_open');
      focusStep();
      if (next === 'intro') count();
      if (next === 'thanks') showApplied();
    }
    function close() {
      cancel(); if (!opened) return;
      opened = false; modal.classList.remove('popup-modal--active'); overlay?.classList.remove('popup-overlay--active'); modal.inert = true;
      blockers.forEach(([el,inert]) => { el.inert = inert; }); blockers = [];
      document.documentElement.style.overflow = restore.html; document.body.style.overflow = restore.body;
      launcher.setAttribute('aria-expanded','false'); syncLauncher();
      const target = origin?.isConnected && !modal.contains(origin) && origin !== document.body ? origin : launcher;
      target.focus({preventScroll:true}); window.scrollTo({left:restore.x,top:restore.y,behavior:'instant'});
      pendingSignup = null; measure('popup_close');
    }
    function registrationSuccess() {
      api.remember(); measure('newsletter_confirmed');
      try { sessionStorage.removeItem(pendingKey); } catch (_) {}
      submitBusy = false; syncLauncher(); open('thanks');
    }
    window.EC_COUPON_UI = {open,close,markUsed,syncLauncher};
    if (brand === 'kokochi') api.signupSuccess = registrationSuccess;
    else window.WD_REGISTRATION_SUCCESS = registrationSuccess;
    modal.inert = true;
    document.addEventListener('click',event => {
      const target = event.target.closest?.('button,a,.popup-overlay');
      if (!target) return;
      if (target.matches('[data-coupon-launcher],.kd-offer-reopen') || target.id === 'wd-offer-launcher') { event.preventDefault(); open(); return; }
      if (modal.contains(target) && target.matches('[data-close],.qp-close')) { event.preventDefault(); close(); return; }
      if (preview && target.matches('[data-replay]')) { open('intro'); return; }
      if (target.id === 'start-quiz') { setStep('quiz'); focusStep(); measure('popup_quiz_open'); return; }
      if (modal.contains(target) && target.matches('[data-qp-answer]')) {
        if (transition) return;
        state.answer = target.dataset.qpAnswer; save(); updateTags();
        target.classList.add('is-selected'); measure('popup_quiz_'+state.answer);
        transition = setTimeout(() => { transition = null; target.classList.remove('is-selected'); setStep('email'); focusStep(); }, reduced ? 0 : 300);
      }
    });
    function updateTags() {
      tags.value = ['newsletter','coupon-flow-20260908',preview ? 'coupon-preview' : 'coupon-live',state.answer ? 'quiz-'+state.answer : null].filter(Boolean).join(',');
    }
    updateTags();
    form.addEventListener('submit',event => {
      if (!state.answer) { event.preventDefault(); setStep('quiz'); focusStep(); return; }
      if (submitBusy || !form.reportValidity()) { event.preventDefault(); return; }
      updateTags();
      const data = {answer:state.answer,y:restore?.y ?? window.scrollY,at:Date.now()};
      try { sessionStorage.setItem(pendingKey,JSON.stringify(data)); } catch (_) {}
      // Leave native submission and Shopify captcha injection untouched.
      submitBusy = true; measure('newsletter_submit');
      setTimeout(() => { submitBusy = false; },15000);
    });
    document.addEventListener('keydown',event => {
      if (!opened) return;
      if (event.key === 'Escape') { event.preventDefault(); close(); return; }
      if (event.key !== 'Tab') return;
      const elements = [...modal.querySelectorAll('button:not(:disabled),input:not([type=hidden]):not(:disabled),a[href]')].filter(el => !el.closest('[hidden]') && el.getClientRects().length);
      const first = elements[0], last = elements.at(-1);
      if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
      else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
    });
    // Coupon state changes elsewhere (checkout without offer, special offer) update the launcher label.
    document.addEventListener('kd:offer-state', syncLauncher);
    document.addEventListener('wandry:newsletter-eligible', syncLauncher);
    window.addEventListener('pageshow', event => { if (event.persisted) { submitBusy = false; if (isUsed()) { launcher.hidden = true; return; } syncLauncher(); schedule(); } });
    if (pendingSignup?.answer && !state.answer) { state.answer = pendingSignup.answer; updateTags(); }
    const success = !!form.querySelector('[data-kd-newsletter-success],[data-wd-newsletter-success]');
    const errors = !!form.querySelector('[aria-invalid=true],.form__message');
    if (isUsed()) { if (api.forget) api.forget(); launcher.hidden = true; stripOwnCode(); return; }   // 購入完了後は割引・ポップアップ・ボタンを出さない
    if (config.dataset.registered === 'true') api.remember();
    if (success && pendingSignup && Date.now()-pendingSignup.at < 3600000) { registrationSuccess(); return; }
    if (errors) { open('email'); return; }
    if (preview && steps[stage]) { open(stage); return; }
    if (api.isEligible() && !replay) {
      detectPurchase().then(used => { if (used) return; syncLauncher(); api.apply().catch(() => {}); });
      return;
    }
    syncLauncher();
    function schedule() {
      clearTimeout(timer);
      if (document.visibilityState !== 'visible' || state.seen || opened || isUsed()) return;
      timer = setTimeout(() => {
        if (document.querySelector('cart-drawer.active,.cart-drawer.active')) { schedule(); return; }
        open(replay ? 'intro' : undefined);
      },20000);
    }
    document.addEventListener('visibilitychange',schedule);
    schedule();
  }
  if (document.readyState !== 'complete') document.addEventListener('DOMContentLoaded',init,{once:true}); else init();
})();
